<template>
  <section>
    <AdminHeader
      v-bind:headerName="$t('newUi.sideBarData.formsTitle')"
      view_form=""
    />

    <div style="display:flex;justify-content: flex-end;">
      <selectLocale
        style="color: #94b978; margin-top:15px;     margin-right: 15px;"
      />
    </div>
    <div class="sellwell-extension-content">
      <div
        class="guide-container d-flex-col"
        style="border-bottom: 1px solid #ccc; "
      >
        <div class="heading mt2">
          {{ $t("newUi.pluginGuide.head1") }}
        </div>
        <div class="d-flex-row mt2">
          <div class="d-flex-col flex1">
            <div class="step">
              {{ $t("newUi.pluginGuide.step1") }}
            </div>
            <div class="content mt1">
              {{ $t("newUi.pluginGuide.info1") }}
            </div>
            <div
              class="button-green mt2"
              style="cursor: pointer"
              @click="navigateTOChromeStore()"
            >
              <img
                src="./../assets/img/guide/chrom.svg"
                alt="step1"
                style="width: 20px;"
              />
              <span style=" position: relative;top: -3px;left: 3px;">
                {{ $t("newUi.pluginGuide.GoToChromeStore") }}</span
              >
            </div>
          </div>
          <div class="flex1">
            <img
              src="./../assets/img/guide/chromeStoreSnap.png"
              alt="step1"
              style="width: 100%;border-radius: 5px;"
            />
          </div>
        </div>

        <div class="d-flex-row mt2">
          <div class="d-flex-col flex1">
            <div class="step">
              {{ $t("newUi.pluginGuide.step2") }}
            </div>
            <div
              class="content mt1"
              v-html="translateHref($t('newUi.pluginGuide.info2'))"
            ></div>
          </div>
          <div class="flex1">
            <img
              src="./../assets/img/guide/pluginStep2.jpg"
              alt="step1"
              style="width: 100%;border-radius: 5px;"
            />
          </div>
        </div>
      </div>

      <div class="guide-container d-flex-col">
        <div class="heading mt2">
          {{ $t("newUi.pluginGuide.head2") }}
        </div>
        <div class="d-flex-row mt2">
          <div class="d-flex-col flex1">
            <div class="step">
              {{ $t("newUi.pluginGuide.subhead1") }}
            </div>
            <div class="content mt1">
              <div v-html="translateHref($t('newUi.pluginGuide.info3'))"></div>
            </div>
            <div
              class="mt1"
              v-html="translateHref($t('newUi.pluginGuide.info4'))"
            ></div>
          </div>
          <div class="flex1">
            <img
              src="./../assets/img/guide/pluginExtStep1.jpg"
              alt="step1"
              style="width: 100%;border-radius: 5px;"
            />
          </div>
        </div>

        <div class="d-flex-row mt2">
          <div class="d-flex-col flex1">
            <div class="step">
              {{ $t("newUi.pluginGuide.subhead2") }}
            </div>
            <div
              class="content mt1"
              v-html="translateHref($t('newUi.pluginGuide.info5'))"
            ></div>
          </div>
          <div class="flex1">
            <img
              src="./../assets/img/guide/pluginExtStep2.jpg"
              alt="step1"
              style="width: 100%;border-radius: 5px;"
            />
          </div>
        </div>

        <div class="d-flex-row mt2">
          <div class="d-flex-col flex1">
            <div class="step">
              {{ $t("newUi.pluginGuide.subhead3") }}
            </div>
            <div class="content mt1">
              {{ $t("newUi.pluginGuide.info6") }}
            </div>
          </div>
          <div class="flex1">
            <img
              src="./../assets/img/guide/pluginExtStep3.jpg"
              alt="step1"
              style="width: 100%;border-radius: 5px;"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AdminHeader from "@/layout/adminHeader.vue";
import selectLocale from "../components/selectLocale";
export default {
  data() {
    return {
      name: "",
      showMessage: false,
      locale: "Deutsch",
      set_overlay: false,
    };
  },
  props: [],
  components: {
    AdminHeader,
    selectLocale,
  },
  methods: {
    translateHref: function(message) {
      console.log(message);
      // return message;

      let val = `<a href="https://web.whatsapp.com/" target="_blank" class="link">  web.whatsapp.com  </a>`;
      let answer = message.replace("$$web.whatsapp$$", val);

      return answer;
    },
    navigateTOChromeStore: function() {
      window.open(process.env.VUE_APP_SELLWELL_EXTENSION, "_blank");
    },
  },
};
</script>

<style scoped>
@media (min-width: 700px) {
  .container {
    background-color: lightblue;
    flex-direction: column;
  }
  .group {
    flex-direction: row;
  }
}

.guide-container {
  /* */
  margin: 3rem 6rem;
}
.heading {
  color: #31333e;
  font-size: 24px;
  font-weight: bold;
}
.d-flex-col {
  display: flex;
  flex-direction: column;
}
.d-flex-row {
  display: flex;
  flex-direction: row;
}
.step {
  color: #8ab26d;
  font-size: 16px;
  font-weight: bold;
}
.content {
  font-size: 14px;
  color: rgb(20, 20, 20);
  text-align: justify;
  padding: 10px 40px 0px 0px;
}
.flex1 {
  flex: 1;
}
.mt1 {
  margin-top: 1rem;
}
.mt2 {
  margin-top: 2rem;
}
.button-green {
  width: 15rem;
  padding: 10px 10px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  border-radius: 5px;
  background: #8ab26d;
}
.link {
  color: #128c7e;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .sellwell-extension-content .guide-container {
    margin: 0 16px;
  }
}
@media (max-width: 767px) {
  .sellwell-extension-content .guide-container .d-flex-row {
    flex-wrap: wrap;
  }

  .sellwell-extension-content .guide-container .d-flex-row .flex1 {
    flex: initial;
    width: 100%;
  }
  .sellwell-extension-content .guide-container .d-flex-row .d-flex-col {
    order: 1;
    margin-top: 15px;
  }
  .sellwell-extension-content .guide-container .heading.mt2 {
    margin-top: 0;
  }
  .sellwell-extension-content .guide-container .d-flex-row + .d-flex-row {
    padding-top: 30px;
    margin-top: 30px;
    border-top: 1px solid rgb(204, 204, 204);
  }
  .sellwell-extension-content .guide-container + .guide-container {
    padding-top: 30px;
    margin-top: 30px;
    border-top: 1px solid rgb(204, 204, 204);
  }
  .sellwell-extension-content .guide-container {
    border-bottom: 0 !important;
  }
  .sellwell-extension-content {
    padding-bottom: 30px;
  }
  .sellwell-extension-content .guide-container .content {
    padding-right: 0;
  }
}
</style>
